define('Components/InstagramWidget/js/InstagramWidget',['hooks',
        'Components/InstagramWidget/js/views/InstagramWidgetInstanceView',
        'Components/InstagramWidget/js/models/InstagramWidgetInstanceModel',
        'Components/InstagramWidget/js/views/InstagramDefaultView',
        'Components/InstagramWidget/js/views/InstagramCarouselView'
    ],
    function (hooks, InstagramWidgetInstanceView, InstagramWidgetInstanceModel,
              InstagramDefaultView,
              InstagramCarouselView) {

        return function () {
            hooks.registerWidgetInstance(
                'InstagramWidget',
                {
                    'default': InstagramDefaultView,
                    'carousel': InstagramCarouselView
                },
                InstagramWidgetInstanceModel
            );
        }
    });
